// extracted by mini-css-extract-plugin
export default {"footer":"index_footer__Fp4ea"};